import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../../utils/axiosConfig';
import config from '../../config';
import useActivePeriod from '../../hooks/useActivePeriod';

const { Title } = Typography;

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { hasActivePeriod } = useActivePeriod();

    const onFinish = async (values) => {
        try {
            setLoading(true);
            setErrorMessage('');

            const response = await axios.post(`${config.apiUrl}/api/v1/login`, {
                email: values.email,
                password: values.password,
            });

            if (response.data.success) {
                const permissions = response.data.permissions || [];
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify({ ...response.data.user, permissions }));

                const role = response?.data?.user?.roles?.[0]?.name;
                if (role === 'admin' || role === 'staff') {
                    navigate('/admin/student-list');
                } else {
                    navigate('/student-profile');
                }
            } else {
                const errorMsg = response.data.message || 'Đăng nhập thất bại!';
                setErrorMessage(errorMsg);
                message.error(errorMsg);
            }
        } catch (error) {
            console.error('Login error:', error);
            const errorMsg = error.response?.data?.message ||
                'Có lỗi xảy ra khi đăng nhập. Vui lòng thử lại!';
            setErrorMessage(errorMsg);
            message.error(errorMsg);

            if (error.response?.data?.error_code === 'EMAIL_NOT_VERIFIED') {
                if (error.response?.data?.token) {
                    localStorage.setItem('token', error.response.data.token);
                }
                if (error.response?.data?.user) {
                    localStorage.setItem('user', JSON.stringify(error.response.data.user));
                }
                navigate('/unverified');
            }
        } finally {
            setLoading(false);
        }
    };

    const validateEmail = (_, value) => {
        if (!value) {
            return Promise.reject('Vui lòng nhập email!');
        }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(value)) {
            return Promise.reject('Email không đúng định dạng!');
        }

        if (value.length > 255) {
            return Promise.reject('Email không được vượt quá 255 ký tự!');
        }

        return Promise.resolve();
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: '#f0f2f5'
        }}>
            <Card style={{
                width: '100%',
                maxWidth: 400,
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <Title level={2}>Đăng nhập</Title>
                    <Title level={4} style={{ color: '#666', fontWeight: 'normal' }}>
                        UTT ADMISSION SYSTEM
                    </Title>
                </div>

                {errorMessage && (
                    <Alert
                        message={errorMessage}
                        type="error"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                )}

                <Form
                    name="login"
                    onFinish={onFinish}
                    layout="vertical"
                    requiredMark={false}
                >
                    <Form.Item
                        name="email"
                        rules={[{ validator: validateEmail }]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            placeholder="Email"
                            size="large"
                            maxLength={255}
                            autoComplete="username"
                        />
                    </Form.Item>

                    <Form.Item name="password">
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="Mật khẩu"
                            size="large"
                            maxLength={50}
                            autoComplete="current-password"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            size="large"
                        >
                            Đăng nhập
                        </Button>
                    </Form.Item>

                    <div style={{ textAlign: 'center' }}>
                        <Link to="/forgot-password">Quên mật khẩu?</Link>
                        {hasActivePeriod && (
                            <div style={{ margin: '8px 0' }}>
                                Chưa có tài khoản? <Link to="/register">Đăng ký ngay</Link>
                            </div>
                        )}
                    </div>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
